<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="modal detail_box"
      style="z-index:999"
    >
      <div
        class="detail"
        element-loading-text="上传中，请稍后"
        v-loading='isUploading'
      >
        <div class="titles msp_icon_close">
          <span class="title_name">上传图片至媒资库</span>
          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>
        <div class="detail_el_scroll">
          <div
            class="uploadpic_title"
            v-if="imgList.length > 0"
          >
            <el-button
              v-if="!isUploading"
              type="primary"
              @click.native='choiceMatterFolder()'
            >文件夹选择</el-button>
            <span class="folder_active">{{ currentMatterFolder.currentFolderLocation }}</span>
            <span class="upload_pic_num">
              <span>图片数量：</span>
              <span class="folder_active">{{ imgList.length }}张</span>
            </span>
          </div>

          <div
            v-if="imgList.length > 0"
            class="bottom_button"
          >
            <div
              v-if="!isUploading"
              class="bottom_content left_info"
            >
              <el-checkbox
                v-model="isCheckedAll"
                @change="changeAllPic"
              >全选</el-checkbox>
              <span
                v-if="isShowOperateButton"
                class="operate_button"
                @click.stop="batchChangePicInfo()"
              >批量修改信息</span>
              <span
                v-if="isShowOperateButton"
                class="operate_button"
                @click.stop="batchDeletePic()"
              >批量删除</span>
            </div>
            <div
              v-if="!isUploading"
              class="bottom_content right_button"
            >
              <el-button
                type="primary"
                @click.native="sureUploadPic()"
              >确定上传</el-button>
            </div>
          </div>

          <div
            v-if="imgList.length > 0"
            class="upload_pic_list"
          >
            <div
              v-for="(item,index) in imgList"
              :key="index"
              class="each_upload_pic"
            >
              <img
                :src="item.url"
                :title="item"
                class="img_box"
                alt=""
              >
              <div
                v-if="!isUploading"
                class="check_box"
              >
                <el-checkbox v-model="item.isChoice" />
              </div>
              <!-- eslint-disable -->
              <div
                v-if="!isUploading"
                class="upload_opacity"
                @click.stop="choiceOrCancleCurrentPic(item)"
              >
                <div
                  class="img_title"
                  :title="item.title"
                >
                  {{ item.title }}
                </div>
                <div class="editor_delete">
                  <span
                    class="iconfont icon-bianji"
                    @click.stop="editorImgInfo(item)"
                  ></span>
                  <span
                    class="iconfont el-icon-delete"
                    @click.stop="deleteCurrentPic(index)"
                  ></span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
export default {
  data () {
    return {
      visible: false,
      isCheckedAll: false,
      imgList: [],
      currentEditPic: '',
      aliyundata: '',
      isUploading: false,
      currentMatterFolder: ''
    }
  },
  mixins: [logsMixins],
  computed: {
    isShowOperateButton () {
      var k = 0
      for (var i = 0; i < this.imgList.length; i++) {
        if (!this.imgList[i].isChoice) {
          k++
        } else {
          break
        }
      }
      if (k === this.imgList.length) {
        return false
      } else {
        return true
      }
    },

  },
  watch: {
    visible () {
      if (!this.visible) {
        this.isCheckedAll = false
        this.imgList = []
        this.currentEditPic = ''
        this.aliyundata = ''
        this.isUploading = false
        this.currentMatterFolder = ''
      }
    },
  },
  mounted () {
    this.$root.eventHub.$on('uploadpicModel', (data) => {
      this.visible = true
      this.imgList = data
      this.getLastFolderChoice()
    })
    this.$root.eventHub.$on('setOrgpicModel', (data, dataList) => {
      this.currentEditPic = data
      this.imgList = dataList
    })
    this.$root.eventHub.$on('getCurrentMatterFolder', (data) => {
      if (this.visible) {
        this.currentMatterFolder = data
      }

    })

  },

  destroyed () {
    this.$root.eventHub.$off('uploadpicModel')
    this.$root.eventHub.$off('setOrgpicModel')
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    editorImgInfo (item) {
      this.$root.eventHub.$emit('changeUploadPicModel', item, this.imgList)
      this.currentEditPic = item
    },

    changeAllPic (val) {
      if (val) {
        for (var i = 0; i < this.imgList.length; i++) {
          this.$set(this.imgList[i], 'isChoice', true)
        }
      } else {
        for (var j = 0; j < this.imgList.length; j++) {
          this.$set(this.imgList[j], 'isChoice', false)
        }
      }
    },
    batchChangePicInfo () {
      this.$root.eventHub.$emit('batchModifyInfoModel', this.imgList, 'uploadType')
    },
    deleteCurrentPic (index) {
      this.imgList.splice(index, 1)
    },
    batchDeletePic () {
      var arr = []
      for (var i = 0; i < this.imgList.length; i++) {
        if (!this.imgList[i].isChoice) {
          arr.push(this.imgList[i])
        }
      }
      this.imgList = arr
      this.isCheckedAll = false
    },
    sureUploadPic () {
      if (this.currentMatterFolder) {
        this.isUploading = true
        var params = {
          materials: this.imgList,
          id_repo: this.currentMatterFolder.id_repo,
          id_folder: this.currentMatterFolder.id
        }
        var option = {
          ...this.$store.getters.baseOption,
          params: params
        }
        api._post(_IMGFILEURL_ + 'picture/addFormArticle', option).then((resp) => {
          if (resp.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '操作成功'
            })
            this.visible = false
          }
          this.isUploading = false

        }).catch((error) => {
          console.log(error)
          this.isUploading = false
        })
      } else {
        this.$notify.warning({
          title: '警告',
          message: '请选择需要保存的素材文件夹'
        })
      }
    },
    choiceMatterFolder () {
      this.$root.eventHub.$emit('setMatterPositionModel', this.currentMatterFolder, 'picToMatter')
    },
    choiceOrCancleCurrentPic (item) {
      this.$set(item, 'isChoice', !item.isChoice)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.detail_box
  .detail
    position relative
    width 780px
    height 500px
    border-radius 6px
    background #FFFFFF
    box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)

    .titles
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      background #fff
      box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

      .title_name
        float left
        color #303133
        font-size 16px
        line-height 48px

      .iconfont
        float right
        color #606266
        font-size 22px
        line-height 48px
        cursor pointer

    .detail_el_scroll
      position relative
      box-sizing border-box
      height calc(100% - 48px)

      .uploadpic_title
        clear both
        box-sizing border-box
        padding 20px

        button
          margin-right 10px
          padding 0
          width 100px
          height 32px
          line-height 32px

        span
          color #606266
          font-size 14px

        .folder_active
          color #688EFF

        .upload_pic_num
          float right

      .bottom_button
        position absolute
        bottom 0
        left 0
        clear both
        box-sizing border-box
        padding-right 20px
        padding-left 20px
        width 100%
        height 60px

        .bottom_content
          display flex
          align-items center
          height 60px

        .right_button
          float right

          button
            padding 0
            width 110px
            height 38px

        .left_info
          float left

          .operate_button
            margin-left 20px
            color #F56969
            font-size 14px
            cursor pointer

      .upload_pic_list
        position relative
        clear both
        overflow auto
        height calc(100% - 134px)

        .each_upload_pic
          position relative
          display flex
          justify-content center
          align-items center
          float left
          margin-bottom 10px
          margin-left 10px
          width 180px
          height 140px
          border 1px solid #E3E3E3
          border-radius 5px

          &:hover
            .upload_opacity
              display block

          img
            max-width 180px
            max-height 140px
            object-fit contain

          .check_box
            position absolute
            top -10px
            left 0

          .upload_opacity
            position absolute
            top 0
            left 0
            display none
            width 100%
            height 100%
            background rgba(0, 0, 0, 0.5)
            cursor pointer

            .editor_delete
              position absolute
              right 10px
              bottom 6px

              span
                margin-left 4px
                color #fff
                cursor pointer

            .img_title
              overflow hidden
              box-sizing border-box
              margin-left 20px
              width 86%
              color #fff
              text-overflow ellipsis
              white-space nowrap
              font-size 14px
</style>
